export const PROJECT_KEY = process.env.REACT_APP_PROJECT_KEY
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME
export const SECRET_KEY = process.env.REACT_APP_PROJECT_KEY === '001' ? '!atease@1234' : `!atease@1234#${process.env.REACT_APP_PROJECT_KEY}`
export const FCM_VAPID = 'BGFMRf2uCKXNDtUYhMlh5uPFS6X6iok6wI6o4ktPjPQp6kUqUkDgCZyYuZUp9n9iRJhXRRLgNsZrIkYXYvRTRW8'